import { Play } from "lucide-react";
import { absUrl } from "@/lib/api";

// Small preview for an uploaded media item (image or video).
export default function MediaThumb({ item, className = "h-20 w-20" }) {
  const src = absUrl(item.url);
  return (
    <div className={`relative shrink-0 overflow-hidden rounded-lg border border-[#2a2a34] bg-black ${className}`}>
      {item.type === "video" ? (
        <>
          <video src={src} muted playsInline preload="metadata" className="h-full w-full object-cover" />
          <span className="absolute inset-0 flex items-center justify-center bg-black/30 text-white"><Play className="h-4 w-4 fill-current" /></span>
        </>
      ) : (
        <img src={src} alt="" className="h-full w-full object-cover" />
      )}
    </div>
  );
}
